{
  "devicesPage": {
    "item": {
      "empty": "Выберите устройство или группу"
    }
  }
}